/**
 * A2A application contract version 1.
 *
 * Concrete wire interfaces and schema objects are generated from the Python
 * Pydantic contract. Generic helpers in this module preserve the relationship
 * between a skill id and that skill's input, resume, signal, pause, output, and
 * artifact types.
 */
export * from "./contracts.js";
export * from "./generated/metadata.js";
export * from "./generated/schemas.js";
export * from "./generated/semantic-conformance.js";
export * from "./generated/skill-definitions.js";
export * from "./generated/types.js";
export * from "./runtime.js";
